<template>
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>ic_vitals_24</title>
        <g id="ic_vitals_24" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="vital_signs_FILL1_wght400_GRAD0_opsz48" transform="translate(2.000000, 5.000000)" :fill="color" fill-rule="nonzero">
                <path d="M7.29166667,13.5714286 C7.04475309,13.5714286 6.82098765,13.5009886 6.62037037,13.3601087 C6.41975309,13.2192289 6.2808642,13.0392157 6.2037037,12.8200692 L3.95833333,7.46663371 L0,7.46663371 L0,6.0578349 L4.93055556,6.0578349 L7.29166667,11.7165101 L11.6203704,0.751359367 C11.6975309,0.532212885 11.8364198,0.352199703 12.037037,0.211319822 C12.2376543,0.0704399407 12.4614198,0 12.7083333,0 C12.9552469,0 13.1790123,0.0704399407 13.3796296,0.211319822 C13.5802469,0.352199703 13.7191358,0.532212885 13.7962963,0.751359367 L16.0416667,6.0578349 L20,6.0578349 L20,7.46663371 L15.0694444,7.46663371 L12.7083333,1.85491844 L8.37962963,12.8200692 C8.30246914,13.0392157 8.16358025,13.2192289 7.96296296,13.3601087 C7.76234568,13.5009886 7.53858025,13.5714286 7.29166667,13.5714286 Z" id="Path"></path>
            </g>
        </g>
    </svg>
</template>

<script>
  export default {
    name: 'IconVitals',
    props: {
       color: {
       type: String,
       default: "#FFFFFF",
       },
    }
  }
</script>